// @ts-nocheck

import * as SpineAnimationAssets from '../../../assets/spine/animations';
import { SpineAnimationIds } from '../../../types/animations';

import { MpAnimationSkins, MpAnimationTypeCards } from './animations';

export const MonopolyFrSpineAnimations = {
  // SOLO CARDS
  [SpineAnimationIds.MP_WIN_FR_CARD_BROWN_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.BROWN_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_BROWN_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.BROWN_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_LIGHT_BLUE_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.LIGHT_BLUE_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_LIGHT_BLUE_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.LIGHT_BLUE_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_LIGHT_BLUE_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.LIGHT_BLUE_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_PURPLE_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.PURPLE_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_PURPLE_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.PURPLE_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_PURPLE_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.PURPLE_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ORANGE_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ORANGE_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ORANGE_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ORANGE_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ORANGE_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ORANGE_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ORANGE_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ORANGE_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ORANGE_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ORANGE_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ORANGE_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ORANGE_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_RED_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.RED_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_RED_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.RED_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_RED_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.RED_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_YELLOW_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.YELLOW_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_YELLOW_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.YELLOW_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_YELLOW_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.YELLOW_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_GREEN_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.GREEN_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_GREEN_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.GREEN_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_GREEN_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.GREEN_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_DARK_BLUE_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.DARK_BLUE_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_DARK_BLUE_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.DARK_BLUE_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ENERGY_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ENERGY_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_ENERGY_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.ENERGY_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_STATION_1]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.STATION_1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_STATION_2]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.STATION_2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_STATION_3]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.STATION_3,
      forwards: true,
    },
  ],
  [SpineAnimationIds.MP_WIN_FR_CARD_STATION_4]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_CARD_SOLO,
      skin: MpAnimationSkins.STATION_4,
      forwards: true,
    },
  ],

  // FAMILIES
  [SpineAnimationIds.MP_WIN_FR_FAMILY_BROWN]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_2,
      skin: MpAnimationSkins.COLLECTION_BROWN,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_LIGHT_BLUE]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_3,
      skin: MpAnimationSkins.COLLECTION_LIGHT_BLUE,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_PURPLE]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_3,
      skin: MpAnimationSkins.COLLECTION_PURPLE,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_ORANGE]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_3,
      skin: MpAnimationSkins.COLLECTION_ORANGE,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_RED]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_3,
      skin: MpAnimationSkins.COLLECTION_RED,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_YELLOW]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_3,
      skin: MpAnimationSkins.COLLECTION_YELLOW,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_GREEN]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_3,
      skin: MpAnimationSkins.COLLECTION_GREEN,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_DARK_BLUE]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_2,
      skin: MpAnimationSkins.COLLECTION_DARK_BLUE,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_STATION]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_4,
      skin: MpAnimationSkins.COLLECTION_STATION,
      forwards: true,
    },
  ],

  [SpineAnimationIds.MP_WIN_FR_FAMILY_ENERGY]: [
    {
      assets: SpineAnimationAssets.MonopolyFr,
      animation: MpAnimationTypeCards.WIN_FAMILY_2,
      skin: MpAnimationSkins.COLLECTION_ENERGY,
      forwards: true,
    },
  ],
};
